import { request } from "@/utils/request";

//  视频学习任务
const taskApi = {
  // 列表
  taskList(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/list/taskList",
      data
    });
  },
  //  添加视频任务
  addTask(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/add/addTask",
      data
    });
  },
  // 编辑视频任务
  editTask(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/edit/editTask",
      data
    });
  },
  // 任务置顶
  taskSort(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/options/taskSort",
      data
    });
  },
  // 任务锁定
  taskLock(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/options/taskLock",
      data
    });
  },
  // 任务删除
  taskDel(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/options/taskDel",
      data
    });
  },
  // 获取任务配置
  getTaskConfig(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/edit/getTaskConfig",
      data
    });
  },
  // 学习记录
  taskRecord(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/record/taskRecord",
      data
    });
  },
  // 学习记录详情
  taskRecordDetail(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/record/taskRecordDetail",
      data
    });
  },
  // 统计分析 获取任务信息
  taskStat(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/stat/taskStat",
      data
    });
  },
  // 统计分析 获取学员信息
  taskStu(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/stat/taskStu",
      data
    });
  },
  // 统计分析 获取学员完成数量详细
  studetial(data) {
    return request({
      method: "POST",
      url: "/api/videoTask/stat/studetial",
      data
    });
  }
};

export default taskApi;
